import { createReducer, on } from '@ngrx/store';

import { IListMyOrdersResult } from '@shared/models/orders';

import {
  resetMyOrdersAction,
  listMyOrdersAction,
  listMyOrdersActionSuccess,
  listMyOrdersActionFailure,
} from './my-orders.actions';

export interface MyOrdersState {
  orders: {
    loading: boolean;
    errors: boolean;
    pageOfOrders?: IListMyOrdersResult['listMyOrders'];
  };
}

export const initialState: MyOrdersState = {
  orders: {
    loading: false,
    errors: false,
    pageOfOrders: undefined,
  },
};

export const myOrdersReducer = createReducer(
  initialState,
  on(resetMyOrdersAction, () => ({ ...initialState })),

  on(listMyOrdersAction, (state) => ({
    ...state,
    orders: {
      ...state.orders,
      loading: true,
    },
  })),
  on(listMyOrdersActionSuccess, (state, action) => ({
    ...state,
    orders: {
      ...state.orders,
      loading: false,
      errors: false,
      pageOfOrders: action.listMyOrders,
    },
  })),
  on(listMyOrdersActionFailure, (state) => ({
    ...state,
    orders: {
      ...state.orders,
      loading: false,
      errors: true,
    },
  }))
);
